<template>
  <div class="footer-containt">
    <div class="footer-top">
      <div class="left-side">
        <div class="logo-info">
          <div class="logo">
            <img
              @click="goTo('Home')"
              :src="$store.getters.images.footer_logo"
              style="width: 75px;"
            />
          </div>

            <div class="info">
              <div v-on:click="openWhatsapp" v-if="$store.getters.billingCompany.phone_number" style="cursor: pointer; margin-top: 10px ; display: flex; color: white;">
                <img :src="$config.whatsapp" style="height: 30px; width: 30px;" />
                <div style="margin-top: 7px;" class="address-country">
                  {{ $store.getters.billingCompany.phone_number }}
                </div> 
              </div>

            <!-- <div  v-for="(address, country) in addresses" :key="country">
                <span class="address-country">{{ country }}: </span>
                <span class="address">{{ spliceArray(address, 0, address.indexOf('+')) }}</span>
                <br>
                <span class="address">{{ spliceArray(address, address.indexOf('+'), null) }}</span>
            </div> -->
            <a class="email" :href="'mailto:'+ websiteInfo.contact_email">{{websiteInfo.contact_email }}</a>
          </div>
        </div>
        <div class="social-media">
          <t-facebook v-if="websiteInfo.facebook_url != '/'" :onClick="facebook" />
          <t-twitter v-if="websiteInfo.twitter_url != '/'" :onClick="twitter" />
          <t-linkedin v-if="websiteInfo.linkedin_url != '/'" :onClick="linkedin" />
          <t-instagram v-if="websiteInfo.insta_url != '/'" :onClick="instagram" />
          <t-youtube v-if="websiteInfo.youtube_url != '/'" :onClick="youtube" />
          <TeBay v-if="websiteInfo.ebay_url != '/'" :onClick="eBay" />
          <TWhatsapp v-if="websiteInfo.whatsapp_url != '/'" :onClick="whatsapp" />
        </div>
      </div>

      <div class="grow"></div>

      <div class="right-side">
        <div class="section1-2">
          <div class="section">
            <div class="title">{{ $translation($websiteText().footer_first_section_title)}}</div>
            <div class="sub-title" @click="goTo('About Us')">{{ $translation($websiteText().footer_first_section_link_1)}}</div>
            <div class="sub-title" @click="goTo('Contact Us')" >{{ $translation($websiteText().footer_first_section_link_2)}}</div>
            <div class="sub-title" @click="goTo('JobsList')" >{{ $translation($websiteText().job_title)}}</div>
            <div class="sub-title" @click="goTo('BlogList')" >{{ $translation($websiteText().blog_title)}}</div>
            
          </div>

          <div class="grow-sections"></div>

          <div class="section">
            <div class="title">{{ $translation($websiteText().footer_second_section_title)}}</div>
            <div class="sub-title" @click="goTo('Shop')">{{  $translation($websiteText().footer_second_section_link_1) }}</div>
            <div class="sub-title" @click="goTo('Home')">{{  $translation($websiteText().footer_second_section_link_2) }}</div>
          </div>
        </div>
        
        <div class="grow-sections"></div>
        
        <div class="section1-2">
          <div class="section">
            <div class="title">{{  $translation($websiteText().footer_third_section_title) }}</div>
            <div class="sub-title" @click="goToSell()">{{  $translation($websiteText().footer_third_section_link_1) }}</div>
            <div class="sub-title" @click="goTo('RFP')">{{  $translation($websiteText().footer_second_section_link_3) }}</div>
          </div>

          <div class="grow-sections"></div>

          <div class="section">
            <div class="title">{{  $translation($websiteText().footer_fourth_section_title) }}</div>

            <div class="section4">
              <div class="section4-left">
                <div class="sub-title" @click="goTo2('Profile')">{{ $translation($websiteText().footer_forth_section_link_1)}}</div>
                <div class="sub-title" @click="goTo2('Listing')">{{  $translation($websiteText().footer_forth_section_link_2) }}</div>
                <div class="sub-title" @click="goTo2('Inbox')">{{  $translation($websiteText().footer_forth_section_link_3) }}</div>
                <div class="sub-title" @click="goTo2('Notifications')">{{  $translation($websiteText().footer_forth_section_link_4) }}</div>
              </div>

              <div class="section4-right">
                <div class="sub-title" @click="goTo2('Orders')">{{  $translation($websiteText().footer_forth_section_link_5) }}</div>
                <div class="sub-title" @click="goTo2('WatchList')">{{  $translation($websiteText().footer_forth_section_link_6) }}</div>
                <div 
                    v-if="$store.getters.isAuthenticated == false" 
                    class="sub-title" 
                    @click=" openAuthPopup()"
                >
                  {{  $translation($websiteText().footer_forth_section_link_7) }}
                </div>
                <div class="sub-title" v-else @click="logout()"> {{  $translation($websiteText().footer_forth_section_link_8) }}</div>
               
                <div  class="sub-title" @click="goTo2('BecomeAServiceCenter')">{{  $translation("Become A Service Center") }}</div>
              </div>
            </div>
            <div class="section4-mobile">
              <div class="sub-title" @click="goTo2('Profile')">{{  $translation($websiteText().footer_forth_section_link_9) }}</div>
              <div 
                v-if="$store.getters.isAuthenticated == false" 
                class="sub-title" 
                @click=" openAuthPopup()"
              >
                {{ $translation($websiteText().footer_forth_section_link_7) }}
              </div>
              <div class="sub-title" v-else @click="logout()"> {{  $translation($websiteText().footer_forth_section_link_8) }}</div>
              <div  class="sub-title" @click="goTo2('BecomeAServiceCenter')">{{  $translation("Become A Service Center") }}</div>
            </div>
            

          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="rights">{{'©' + websiteInfo.website_url + ' All rights reserved from ' + websiteInfo.launch_year + ' to ' + new Date().getFullYear() }}</div>
      <div class="grow"></div>
      <div class="privacy-terms">
        <div class="footer-privacy" @click="goTo('policy')">{{ $websiteText().footer_privacy_policy_link }}</div>
        <div class="footer-terms" @click="goTo('terms')" >{{ $websiteText().footer_terms_of_service_link }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  LOGOUT,
  TOGGLE_AUTH_POPUP,
} from "../../../../domains/authentication/store/actions";

import TFacebook from "../../icons/TFacebook.vue";
import TInstagram from "../../icons/TInstagram.vue";
import TLinkedin from "../../icons/TLinkedin.vue";
import TeBay from "../../icons/TeBay.vue";
import TTwitter from "../../icons/TTwitter.vue";
import TYoutube from "../../icons/TYoutube.vue";
import TWhatsapp from "../../icons/TWhatsapp";
import { GET_CUSTOMER_LISTINGS } from "../../../../domains/userdashboard/store/listing/actions";
import { GET_WEBSITE_INFO } from "../../../store/actions";
export default {
  data() {
    return {
     
      websiteInfo: {},
      addresses: {},
    };
  },
  components: {
    TFacebook,
    TLinkedin,
    TeBay,
    TInstagram,
    TTwitter,
    TYoutube,
    TWhatsapp,
  },

  computed:{

  },


  methods: {

    async getWebsiteInfo(){
      await this.$store.dispatch(GET_WEBSITE_INFO);
      this.websiteInfo = this.$store.getters.websiteInfo;
      this.addresses = JSON.parse(this.websiteInfo.addresses);
    
    },

    spliceArray(string, start, finish=null){
      let array = []
      array = Array.from(string)
      if(finish===null) return array.splice(start).join("")
      else  return array.splice(start, finish).join("")
    },

    openWhatsapp(){
      window.open("https://wa.me/"+ this.$store.getters.billingCompany.phone_number.replace(/\s/g, ''))
    },

  
    

    openAuthPopup() {
      this.$store.dispatch(TOGGLE_AUTH_POPUP, true);
    },

    logout() {
      this.$store.dispatch(LOGOUT);
      this.goTo("Home");
      window.location.href = "/";
    },

    

    facebook() {
      window.open(this.websiteInfo.facebook_url);
    },
    twitter() {
      window.open(this.websiteInfo.twitter_url);
    },
    linkedin() {
      window.open(this.websiteInfo.linkedin_url);
    },
    instagram() {
      window.open(this.websiteInfo.insta_url);
    },
    youtube() {
      window.open(this.websiteInfo.youtube_url);
    },
    eBay() {
      window.open(this.websiteInfo.ebay_url);
    },
    whatsapp(){
      window.open(this.websiteInfo.whatsapp_url);
    },
    goTo(page) {
      this.$router.push({name: page});
    },

    goTo2(page) {
      if(this.$store.getters.isAuthenticated){
        this.$router.push({name: page});
      }else{
        this.$store.dispatch(TOGGLE_AUTH_POPUP, true);
      }
    },
    goToEmlid(name) {
      this.$router.push({
        name: name,
        params: {
          id: 1,
          name: "Emlid",
        },
      });
    },
    goToPath(path, id) {
      this.$router.push({path: path, hash: "#" + id});
    },

    async goToSell() {
      if (this.$store.getters.isAuthenticated) {
        let getListings = await this.$store.dispatch(GET_CUSTOMER_LISTINGS);
        if (getListings.length > 0) {
          this.$router.push({name: "sell"});
        } else {
          this.$router.push({name: "how-it-works-sell"});
        }
      } else {
        this.$store.dispatch(TOGGLE_AUTH_POPUP, true);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getWebsiteInfo();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/components/layouts/footer.scss";
</style>
